import React, { Suspense, lazy } from 'react'
import PreLoader from '../Common/PreLoader';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../Page/Home";
import BlogDetail from '../Page/Blog/BlogDetail';
//lazy import
const BlogListing = lazy(() => import('../Page/Blog/BlogListing'));
const About = lazy(() => import('../Page/About'));
const Approach = lazy(() => import("../Page/Approach"));
const Products = lazy(() => import("../Page/Products"));
const Contact = lazy(() => import("../Page/Contact"));
const SoftwareDevelopment = lazy(() => import("../Page/Service/SoftwareDevelopment"));
const AppDevelopment = lazy(() => import("../Page/Service/AppDevelopment"));
const MixedReality = lazy(() => import("../Page/Service/MixedReality"));
const DigitalMarketing = lazy(() => import("../Page/Service/DigitalMarketing"));
const Header = lazy(() => import("../Common/Header"));
const Footer = lazy(() => import("../Common/Footer"));
const ClinicMS = lazy(() => import("../Page/Product/ClinicMS"));
const SalonMS = lazy(() => import("../Page/Product/SalonMS"));
const ColdSS = lazy(() => import("../Page/Product/ColdSS"));
const ECommerseS = lazy(() => import("../Page/Product/ECommerseS"));
const LearningMS = lazy(() => import("../Page/Product/LearningMS"));
const CustomerRM = lazy(() => import("../Page/Product/CustomerRM"));
const GameParlorMS = lazy(() => import("../Page/Product/GameParlorMS"));
const EnterpriseRP = lazy(() => import("../Page/Product/EnterpriseRP"));
const BakerySM = lazy(() => import("../Page/Product/BakerySM"));
const FantasyMAD = lazy(() => import("../Page/Product/FantasyMAD"));
const AdmissionMS = lazy(() => import("../Page/Product/AdmissionMS"));
const EsportML = lazy(() => import("../Page/Product/EsportML"));
const Career = lazy(() => import("../Page/Career"));
const Four04page = lazy(() => import("../Page/Four04page"));
const DownloadBook = lazy(() => import("../Page/Books/DownloadBook"));
const UniversityManagSys = lazy(() => import("../Page/Product/UniversityManagSys"));
const Privacy_Policy = lazy(() => import("../Page/Privacy_Policy"));
const WebsiteDevelopment = lazy(() => import("../Page/Service/WebsiteDevelopment"));
const ManPowerSupply = lazy(() => import("../Page/Service/ManPowerSupply"));
const Refund_policy = lazy(() => import("../Page/Refund_policy"));
const Terms_condition = lazy(() => import("../Page/Terms_condition"));


const AllRoutes = () => {
  return (
    <>
      <BrowserRouter>
        <Suspense fallback={<PreLoader />}>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/approach" element={<Approach />} />
            <Route path="/products" element={<Products />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/career" element={<Career />} />
            <Route path="/books" element={<DownloadBook />} />
            <Route path="/service/softwareDevelopment" element={<SoftwareDevelopment />} />
            <Route path="/service/appDevelopment" element={<AppDevelopment />} />
            <Route path="/service/mixedReality" element={<MixedReality />} />
            <Route path="/service/digitalMarketing" element={<DigitalMarketing />} />
            <Route path="/service/websiteDevelopment" element={<WebsiteDevelopment />} />
            <Route path="/service/manpowersupply" element={<ManPowerSupply />} />
            <Route path="/products/clinicMS" element={<ClinicMS />} />
            <Route path="/products/salonMS" element={<SalonMS />} />
            <Route path="/products/coldSS" element={<ColdSS />} />
            <Route path="/products/ecommerseS" element={<ECommerseS />} />
            <Route path="/products/learningMS" element={<LearningMS />} />
            <Route path="/products/customerRM" element={<CustomerRM />} />
            <Route path="/products/gameParlorMS" element={<GameParlorMS />} />
            <Route path="/products/enterpriseRP" element={<EnterpriseRP />} />
            <Route path="/products/bakerySM" element={<BakerySM />} />
            <Route path="/products/fantasyMAD" element={<FantasyMAD />} />
            <Route path="/products/esport" element={<EsportML />} />
            <Route path="/products/admissionMS" element={<AdmissionMS />} />
            <Route path="/products/ums" element={<UniversityManagSys />} />
            <Route path="/privacy_policy" element={<Privacy_Policy />} />
            <Route path="/refund_policy" element={<Refund_policy />} />
            <Route path="/terms_and_conditions" element={<Terms_condition />} />
            <Route path="/blogs" element={<BlogListing />} />
            <Route path="/blogs/:name" element={<BlogDetail />} />
            <Route path="/*" element={<Four04page />} />
          </Routes>
          <Footer />
        </Suspense>
      </BrowserRouter>
    </>
  );
};

export default AllRoutes;
